import type { TV2User } from "../global";

export const initCoral = () => {
  const { coralJwtUrl } = window.AUTH0_CONFIG;

  const getCoralToken = async function () {
    try {
      // Get cached coral token first
      const cachedToken = localStorage.getItem('coral_token');
      const cachedExpiry = localStorage.getItem('coral_token_expiry');

      if (cachedToken && cachedExpiry && Date.now() < parseInt(cachedExpiry)) {
        return cachedToken;
      }

      // Get user data if not provided
      const user = await window.TV2?.getLoggedInUser() as TV2User;

      if (!user || !user.id || !user.email) {
        throw new Error('User not authenticated or missing required fields');
      }

      if (!user.emailConfirmed) {
        throw new Error('User email not confirmed');
      }

      // Request coral token from server
      const response = await fetch(coralJwtUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ user }),
      });

      if (!response.ok) {
        throw new Error(`Failed to get coral token: ${response.status}`);
      }

      const data = await response.json();

      if (!data.success || !data.token) {
        throw new Error('Invalid coral token response');
      }

      // Store token and expiry in localStorage
      const expiryTime = Date.now() + (data.expiresIn * 1000);
      localStorage.setItem('coral_token', data.token);
      localStorage.setItem('coral_token_expiry', expiryTime.toString());

      return data.token;
    } catch (error) {
      console.error('Menu: Error fetching Coral token:', error);

      // Clear any invalid cached tokens
      localStorage.removeItem('coral_token');
      localStorage.removeItem('coral_token_expiry');
    }
  };

  window.TV2 = window.TV2 || {};
  window.TV2 = { ...window.TV2, getCoralToken }

  getCoralToken();
};